import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { formatCurrency, formatPercent } from './radarUtils';

const ValorCapturadoPage = () => {
  const [dias, setDias] = useState(30);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    resolvidos_por_tipo: [],
    abertos_por_tipo: [],
    valor_recuperado_total: 0,
    before_after: {},
  });

  const loadData = async () => {
    try {
      setLoading(true);
      const rs = await axios.get('/api/radar-lucro/valor-capturado', { params: { dias } });
      setData(rs.data || {});
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao carregar valor capturado');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [dias]);

  return (
    <div className="animate-fade-in space-y-4">
      <div className="rounded-xl border border-success-200 bg-success-50 p-4">
        <p className="text-sm font-semibold text-success-800">Valor capturado</p>
        <p className="text-2xl font-bold text-success-900 mt-1">{formatCurrency(data?.valor_recuperado_total)} recuperado no período</p>
        <p className="text-sm text-success-800 mt-1">Mede ganho real com base em alertas resolvidos.</p>
      </div>

      <div className="flex items-center gap-3">
        <select className="form-select w-48" value={dias} onChange={(e) => setDias(Number(e.target.value))}>
          <option value={30}>Últimos 30 dias</option>
          <option value={90}>Últimos 90 dias</option>
          <option value={180}>Últimos 180 dias</option>
          <option value={365}>Últimos 365 dias</option>
        </select>
        <button className="btn-secondary" onClick={loadData} disabled={loading}>
          Atualizar
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Risco (antes/depois)</p><p className="text-lg font-semibold">{formatPercent(data?.before_after?.risco_7d?.variacao_pct)}</p></div></div>
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Capital parado (antes/depois)</p><p className="text-lg font-semibold">{formatPercent(data?.before_after?.capital_parado?.variacao_pct)}</p></div></div>
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Margem impacto (antes/depois)</p><p className="text-lg font-semibold">{formatPercent(data?.before_after?.margem_impacto_30d?.variacao_pct)}</p></div></div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <div className="card">
          <div className="card-header"><h3 className="text-lg font-semibold">Resolvidos por tipo</h3></div>
          <div className="card-body p-0">
            <div className="table-container">
              <table className="table">
                <thead><tr><th>Tipo</th><th>Qtde</th><th>Valor recuperado</th></tr></thead>
                <tbody>
                  {(data?.resolvidos_por_tipo || []).map((r) => (
                    <tr key={r.alert_type}>
                      <td>{r.alert_type}</td>
                      <td>{r.resolvidos}</td>
                      <td>{formatCurrency(r.valor_recuperado)}</td>
                    </tr>
                  ))}
                  {!(data?.resolvidos_por_tipo || []).length && <tr><td colSpan={3} className="text-center text-gray-500 py-6">Sem resoluções no período.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><h3 className="text-lg font-semibold">Abertos por tipo (agora)</h3></div>
          <div className="card-body p-0">
            <div className="table-container">
              <table className="table">
                <thead><tr><th>Tipo</th><th>Qtde</th><th>Valor em risco</th></tr></thead>
                <tbody>
                  {(data?.abertos_por_tipo || []).map((r) => (
                    <tr key={r.alert_type}>
                      <td>{r.alert_type}</td>
                      <td>{r.abertos}</td>
                      <td>{formatCurrency(r.valor_em_risco)}</td>
                    </tr>
                  ))}
                  {!(data?.abertos_por_tipo || []).length && <tr><td colSpan={3} className="text-center text-gray-500 py-6">Sem alertas abertos no momento.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValorCapturadoPage;
